const T_PREFIX = "auth";

export const logoutTrns = {
  logoutButton: `${T_PREFIX}.logout.logout-btn`,
  description: `${T_PREFIX}.logout.description`,
};
